import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
var Progress = function Progress(_ref) {
  var id = _ref.id,
    max = _ref.max,
    value = _ref.value,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "ltr" : _ref$direction,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("progress", {
    id: id,
    max: max,
    value: value,
    style: {
      "direction": direction
    },
    className: twMerge("bg-white h-2 w-full [&::-webkit-progress-bar]:rounded-full [&::-webkit-progress-value]:rounded-full [&::-webkit-progress-bar]:bg-gray-gainsboro [&::-webkit-progress-value]:bg-primary [&::-moz-progress-bar]:bg-primary", className)
  });
};
export default Progress;